import React from 'react';
import { filterDataProps } from '@THC/utils/helpers';

import styles from './ModalHeader.module.scss';

export interface ModalHeaderProps {
	title: string | React.ReactNode;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ title, ...rest }) => (
	<header className={styles.header} {...filterDataProps(rest)}>
		{title}
	</header>
);

export default ModalHeader;
